// Section registry. Eyebrow "/ 0N" numbering derives from it;
// NAV_LINKS is validated against it by sections.test.js.
export const SECTIONS = [
  { id: "services",  num: 1, eyebrow: "Capabilities" },
  { id: "manifesto", num: 2, eyebrow: "Manifesto" },
  { id: "portals",   num: 3, eyebrow: "Portals" },
  { id: "connect",   num: 4, eyebrow: "Connect" },
  { id: "stats" },
];

export const NAV_LINKS = [
  { label: "Services",  href: "#services" },
  { label: "Manifesto", href: "#manifesto" },
  { label: "Network",   href: "#stats" },
  { label: "Portals",   href: "#portals" },
  { label: "Carriers",  href: "#carrier", action: "carrier" }, // opens Connect's carrier tab
];

export const eyebrowFor = (id) => {
  const s = SECTIONS.find((x) => x.id === id);
  return s?.num ? `/ 0${s.num} — ${s.eyebrow}` : "";
};
